export default {
  tabs: {
    access: 'Acceso',
    notification_preferences: 'Preferencias de notificación',
  },
  sections: {
    notification_preferences: {
      title: 'Preferencias de notificación',
      form: {
        has_voice_call_reminders: {
          label: 'Recibir llamadas automáticas sobre pedidos pendientes',
        },
        voice_reminders_phone_number: {
          label: 'Número de teléfono para recibir llamadas',
        },
        has_whatsapp_notifications: {
          label: 'Enviar notificaciones (p. ej. pedidos pausados) por WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'Número de WhatsApp',
        },
        has_order_email_notifications: {
          label: 'Enviar notificaciones de pedidos por correo electrónico',
        },
        order_notifications_email: {
          label: 'Dirección de correo para reenviar notificaciones de pedidos',
        },
      },
    },
    voice_calls: {
      title: 'Llamadas de voz',
    },
    whats_app_notifications: {
      title: 'Notificaciones de WhatsApp',
    },
    order_email_notifications: {
      title: 'Notificaciones de pedidos por correo',
    },
    access_control: {
      title: 'Control de acceso',
      form: {
        company_ids: {
          label: 'Puede acceder a restaurantes',
          tooltip: 'Da acceso a los siguientes restaurantes (además de los restaurantes de la misma marca)',
        },
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Los cambios se han guardado',
  },
};
